export enum AssessmentStatus {
  INVITATION_SENT = 'INVITATION_SENT',
  ACCEPTED = 'ACCEPTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}
